import React, { useState } from 'react';
import MainContainer from 'containers/MainContainer';
import { useRouteMatch } from 'react-router';
import { Switch, Route, Redirect } from 'react-router-dom';
import Summary from './pages/Summary';
import Messages from './pages/Messages';
import Calendar from './pages/Calendar';
import Expediente from './pages/Expediente';
import MisPacientes from './pages/MisPacientes';
import MiTerapeuta from './pages/MiTerapeuta';
import BottomNavBar from './components/BottomNavBar';
import useUser from 'state/user';
import { useEffect } from 'react';
import InfoButton from 'components/InfoButton';
import ALERT_TYPES from 'alert/types';
import { useAlert } from 'alert';
import EmailConfirmationDialog from './components/EmailConfirmationDialog';
import { useSocket } from 'Socket';
import useConversations from 'state/conversations';

const Home = ({ location }) => {
    const { path, url } = useRouteMatch();
    const [menuOpen, setMenuOpen] = useState(false);
    const [user, userDispatcher] = useUser();
    const [, conversationsDispatcher] = useConversations();
    const alert = useAlert();
    const socket = useSocket();

    useEffect(() => {
        conversationsDispatcher.fetchStart();
    }, [conversationsDispatcher]);

    useEffect(()=>{
        if(!socket) return;
        socket.on('new message', (payload)=>{ 
            console.log(payload);
            conversationsDispatcher.addLastMessage(payload);
         });

         return () => {
            socket.off('new message')
         }
    },[socket, conversationsDispatcher]);

    useEffect(() => {
        userDispatcher.fetchStart();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const showEmailConfirmationAlert = () => {
        alert({
            type: ALERT_TYPES.CUSTOM,
            config: {
                body: EmailConfirmationDialog,
                props: {
                    userId: user.current.id,
                },
            },
        })
            .then(() => {})
            .catch(() => {});
    }
 
    return (
        <>
            <MainContainer menuOpen={menuOpen} toggleMenu={toggleMenu}>
                {user.current && !user.current.emailVerified && (
                    <InfoButton
                        style={{ backgroundColor: 'red', fontWeight: '700' }}
                        body={'Verificación de correo pendiente'}
                        onClick={showEmailConfirmationAlert}
                    />
                )}
                <Switch>
                    <Route exact path={path}>
                        <Redirect to={`${url}/resumen`} />
                    </Route>
                    <Route path={`${path}/resumen`} render={() => <Summary toggleMenu={toggleMenu} />} />
                    <Route path={`${path}/mensajes`} render={() => <Messages toggleMenu={toggleMenu} />} />
                    <Route path={`${path}/calendario`} render={() => <Calendar toggleMenu={toggleMenu} />} />
                    <Route path={`${path}/expediente/:clientId`} component={Expediente} />
                    <Route path={`${path}/mis-pacientes`} render={() => <MisPacientes toggleMenu={toggleMenu} />} />
                    <Route path={`${path}/mi-terapeuta`} render={() => <MiTerapeuta toggleMenu={toggleMenu} />} />
                </Switch>
                <BottomNavBar location={location} />
            </MainContainer>
        </>
    );
};

export default Home;
